// Single source of truth for forum category metadata on the client. The
// backend also returns categories via /api/forum/categories — but for icon
// + accent color we keep the mapping here so the UI never blocks on a
// roundtrip. The icon + accent are presentation-only; labels still come
// from the API so they stay authoritative.
import {
  Scale,
  Search as SearchIcon,
  MessagesSquare,
  Building,
  Megaphone,
  Wrench,
  Sparkles,
  HelpCircle,
} from "lucide-react";

export const CATEGORY_META = {
  "contracts-legal":  { icon: Scale,        accent: "#3B82F6" },
  "finding-deals":    { icon: SearchIcon,   accent: "#10B981" },
  "negotiation":      { icon: MessagesSquare, accent: "#F59E0B" },
  "title-closing":    { icon: Building,     accent: "#8B5CF6" },
  "marketing":        { icon: Megaphone,    accent: "#EC4899" },
  "tools-software":   { icon: Wrench,       accent: "#06B6D4" },
  "newbie-questions": { icon: Sparkles,     accent: "#F97316" },
};

// Fallback when a post has a category id we don't yet know about (e.g.
// admin added a new one server-side before this client shipped).
export const FALLBACK_META = { icon: HelpCircle, accent: "#6B7280" };

export function metaFor(categoryId) {
  return CATEGORY_META[categoryId] || FALLBACK_META;
}

// Friendly relative-time formatter shared across forum components.
export function timeAgo(iso) {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.round(diff / 60)}m ago`;
  if (diff < 86_400) return `${Math.round(diff / 3600)}h ago`;
  if (diff < 30 * 86_400) return `${Math.round(diff / 86_400)}d ago`;
  return new Date(iso).toLocaleDateString();
}
